module.exports = __webpack_public_path__ + "img/stock6.6bb2c225.png";